import { useAppSelector } from 'app/hooks'
import { isRoleGreaterThanOrEq, getHighestRole } from 'utils/permissionUtil'
import UserRole from 'enums/UserRole'
import UserPermission from 'enums/UserPermission'

export interface NavBarConfigType {
  hasTabs: {
    homeTab: boolean
    dashboardTab: boolean
    topicTab: boolean
    analysisTab: boolean
    annotationTab: boolean
    aiLabTab: boolean
    quid: boolean
    proTab: boolean
    adminTab: boolean
  }
  userName: string
}

export const useNavBarConfig = (): NavBarConfigType => {
  const userconfig = useAppSelector(({ pageConfig }) => pageConfig.config.user)
  const isLimitedUser =
    userconfig?.userRoles?.some(
      (role: string) => role === UserRole.ROLE_ANNOTATOR || role === UserRole.ROLE_PRO_USER
    ) ?? false

  const hasAnnotationPermission =
    userconfig?.userPermissions.includes(UserPermission.PERMS_MANAGE_ANNOTATION) ?? false

  const hasNetBaseProPermission =
    userconfig?.userPermissions.includes(UserPermission.PERMS_NETBASE_PRO) ?? false

  const hasQuidPermission = userconfig?.featureTest?.split(',').includes('quid') ?? false

  const currentHighestRole = getHighestRole(userconfig?.userRoles ?? [])

  const hasAIPermission =
    isRoleGreaterThanOrEq(currentHighestRole, UserRole.ROLE_BASIC_USER) &&
    userconfig?.userPermissions.includes(UserPermission.PERMS_AI)

  const hasAdminPermission =
    (userconfig?.userPermissions.includes(UserPermission.PERMS_MANAGE_SOCIAL_MEDIA_COVERAGE) ??
      false) ||
    isRoleGreaterThanOrEq(currentHighestRole, UserRole.ROLE_ACCOUNT_ADMIN_USER)

  return {
    hasTabs: {
      homeTab: !isLimitedUser,
      dashboardTab: !isLimitedUser,
      topicTab: !isLimitedUser,
      analysisTab: !isLimitedUser,
      annotationTab: hasAnnotationPermission,
      aiLabTab: hasAIPermission,
      quid: hasQuidPermission,
      proTab: hasNetBaseProPermission,
      adminTab: hasAdminPermission
    },
    userName: userconfig?.name || 'user name'
  }
}
